import { api } from "./api";
import { CostOverview } from "../types/costOverview.type";

export interface ProduceOrderItem {
  _id: string;
  name: string;
  unitOfMeasurement: string;
  sortOrder: number;
  isHidden?: boolean;
}

export const produceApi = {
  // Полный список продукции для экрана ручной сортировки (без пагинации).
  getOrderList: async (showHidden = false): Promise<ProduceOrderItem[]> => {
    const response = await api.get("/produce/order-list", {
      params: showHidden ? { showHidden: "true" } : undefined,
    });
    return response.data;
  },

  // Сохранить новый ручной порядок продукции.
  updateSortOrder: async (
    produces: { id: string; sortOrder: number }[]
  ): Promise<void> => {
    await api.put("/produce/sort/order", { produces });
  },

  // Обзор себестоимости: партии, расчёт по рецептуре и расшифровка расходников.
  getCostOverview: async (produceId: string): Promise<CostOverview> => {
    const response = await api.get(`/produce/${produceId}/cost-overview`);
    return response.data;
  },
};
